import { enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core'
import '@angular/common/locales/global/ru'
import { environment } from './environments/environment'
import { tokenInterceptor } from './app/services/token.interceptor'
import { NZ_DATE_CONFIG, NZ_DATE_LOCALE, NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n'
import { ru as RU } from 'date-fns/locale'
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzMessageService } from 'ng-zorro-antd/message'
import { CanDeactivateGuard } from './app/services/canDeactivateGuard'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { LayoutService } from './app/components/main-layout/layout.service'
import { CommonModule, NgOptimizedImage } from '@angular/common'
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser'
import { provideAnimations } from '@angular/platform-browser/animations'
import { AppRoutingModule } from './app/app-routing.module'
import { LoadingBarModule } from '@ngx-loading-bar/core'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzMenuModule } from 'ng-zorro-antd/menu'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { IconsProviderModule } from './app/icons-provider.module'
import { NzAlertModule } from 'ng-zorro-antd/alert'
import { NzCardModule } from 'ng-zorro-antd/card'
import { ReactiveFormsModule } from '@angular/forms'
import { NzFormModule } from 'ng-zorro-antd/form'
import { NzInputModule } from 'ng-zorro-antd/input'
import { NzTypographyModule } from 'ng-zorro-antd/typography'
import { SortablejsModule } from '@maksim_m/ngx-sortablejs'
import { AppComponent } from './app/app.component'

if (environment.production) {
  enableProdMode()
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: LOCALE_ID, useValue: 'ru' },
    importProvidersFrom(
      CommonModule,
      BrowserModule,
      AppRoutingModule,
      LoadingBarModule,
      NzLayoutModule,
      NzMenuModule,
      NzIconModule,
      NzButtonModule,
      IconsProviderModule,
      NzAlertModule,
      NzCardModule,
      ReactiveFormsModule,
      NzFormModule,
      NzInputModule,
      NzTypographyModule,
      SortablejsModule.forRoot({ animation: 150 }),
      NgOptimizedImage
      // SharedModule
    ),
    tokenInterceptor,
    { provide: NZ_I18N, useValue: ru_RU },
    { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
    { provide: NZ_DATE_LOCALE, useValue: RU },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    NzNotificationService,
    NzMessageService,
    CanDeactivateGuard,
    provideHttpClient(withInterceptorsFromDi()),
    LayoutService,
    provideAnimations(),
  ],
}).catch(err => console.error(err))
